import { render, staticRenderFns } from "./NilaiAkhirSemester.vue?vue&type=template&id=8ce1ff04"
import script from "./NilaiAkhirSemester.vue?vue&type=script&lang=js"
export * from "./NilaiAkhirSemester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports